import * as React from 'react';
import * as _ from 'lodash';
import { PARTS } from './../../../../schemas/accessRightsModel';
export default function () {
    function scopePropsAR1() {
        var props = this.props;
        var AR = this.props.AR;
        return React.createElement('div', { 'className': 'ui-popup-footer ui-popup-footer--flex ' + (this.props.algorithmButtons ? 'algorithm-buttons' : '') }, React.createElement('div', {
            'className': 'ui-popup-footer__left',
            'onClick': this.props.onDelete
        }, this.props.deleteVisible && AR.e(PARTS.ASSIGN_PP_CREATE) ? React.createElement('button', {
            'className': 'ui-button ui-button--red',
            'key': '351'
        }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Delete')) : null), React.createElement('div', { 'className': 'ui-popup-footer__right' }, React.createElement('button', { 'className': 'ui-button ui-button--blue' }, React.createElement('span', {
            'className': 'ui-button-text ui-button--uppercase',
            'onClick': this.props.onCancel
        }, 'Cancel')), this.props.selectVisible ? React.createElement('button', {
            'className': 'ui-button ui-button--green',
            'onClick': this.onSelect,
            'key': '795'
        }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Select')) : null, !this.props.selectVisible && AR.e(PARTS.ASSIGN_PP_CREATE) ? React.createElement('button', {
            'className': 'ui-button ui-button--green',
            'onClick': this.onSave,
            'key': '1001'
        }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Save')) : null));
    }
    return scopePropsAR1.apply(this, []);
}